// turnstile.component.ts
import { Component, ElementRef, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

declare global {
  interface Window {
      turnstile?: {
          render: (element: HTMLElement, options: any) => any;
          remove: (widgetId: any) => void;
      };
  }
}

@Component({
  selector: 'app-turnstile',
  template: `<div #turnstileRef></div>`,
  standalone: true
})
export class TurnstileComponent implements OnInit, OnDestroy {
  @Input() siteKey!: string;
  @Output() token = new EventEmitter<string>();
  @ViewChild('turnstileRef', { static: true }) elRef!: ElementRef;

  private widgetId: any;

  constructor(private zone: NgZone) {}

  ngOnInit(): void {
    const render = () => {
      this.widgetId = window['turnstile']?.render(this.elRef.nativeElement, {
        sitekey: this.siteKey,
        callback: (token: string) => this.zone.run(() => this.token.emit(token)),
        'error-callback': () => this.zone.run(() => this.token.emit('')),
        theme: 'light',
      });
    };

    if (window['turnstile']) {
      render();
    } else {
      const check = setInterval(() => {
        if (window['turnstile']) {
          clearInterval(check);
          render();
        }
      }, 100);
    }
  }

  ngOnDestroy(): void {
    if (window['turnstile'] && this.widgetId !== undefined) {
      window['turnstile'].remove(this.widgetId);
    }
  }
}